import { defineFcm } from '../shared/factory';

export const FCM_DECISION_MAKERS_AUTOADD_ENABLED = defineFcm('decision_makers_autoadd_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig();
